import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/Buttons";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import { SurfaceCard } from "../../../components/ui/SurfaceCard";
import { AppLink } from "../../../components/ui/link";
import { AuthPageLayout } from "./AuthPageLayout";
import type { MainAppPageProps } from "../types";

type ForgotPasswordPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "userForm"
>;

export const ForgotPasswordPage: React.FC<ForgotPasswordPageProps> = ({
  csrfToken,
  routes,
  userForm,
}) => (
  <AuthPageLayout>
    <h1 className="mb-3 text-center font-display text-3xl font-semibold tracking-tight text-foreground">
      Reset your password
    </h1>
    <p className="mb-8 text-center text-sm text-muted-foreground">
      Enter your email and we&apos;ll send reset instructions if an account
      exists.
    </p>
    <SurfaceCard className="rounded-2xl border-border p-8 shadow-lg">
      <form action={routes.forgotPassword} method="post">
        <AuthenticityTokenField csrfToken={csrfToken} />
        <div className="mb-6">
          <FieldLabel htmlFor="email">Email</FieldLabel>
          <TextInput
            id="email"
            name="email"
            type="email"
            defaultValue={userForm?.email ?? ""}
            placeholder="you@example.com"
            required
          />
        </div>
        <Button
          type="submit"
          variant="premium"
          className="w-full py-3 font-medium"
        >
          Send reset link
        </Button>
      </form>
    </SurfaceCard>
    <p className="mt-6 text-center text-sm text-muted-foreground">
      <AppLink to={routes.login} variant="premium">
        Back to log in
      </AppLink>
    </p>
  </AuthPageLayout>
);
